import { Button, Icon, Spinner } from '@acpaas-ui/react-components';
import { useCallback, useRef } from 'react';
import { useDropzone } from 'react-dropzone';
import { MAX_SIZE_MEDIA, MAX_SIZE_MEDIA_TEXT } from '../../constants/settings.constants';
import LinkButton from './LinkButton';

const DEFAULT_MAX_SIZE_ERROR = `Dit bestand is te groot, max ${MAX_SIZE_MEDIA_TEXT}.`;
const DEFAULT_MAX_SIZE_DESCRIPTION = `Maximum bestandsgrootte: ${MAX_SIZE_MEDIA_TEXT}`;

const FileUpload = ({
  files = [],
  required,
  onChange,
  onDelete,
  onOpen,
  multiple,
  disabled,
  isLoading,
  acceptedFormat = '*'
}) => {
  const inputRef = useRef(null);
  const onDrop = useCallback(
    (files) => {
      onChange && onChange(files);
      inputRef.current.value = '';
    },
    [onChange]
  );
  const { getRootProps, isDragActive } = useDropzone({ onDrop });
  const onSelect = (event) => {
    onChange && onChange(event.target.files);
    inputRef.current.value = '';
  };
  const handleDelete = (file) => {
    onDelete(file);
    inputRef.current.value = '';
  };

  return (
    <div className={`spo-m-file-upload m-upload ${disabled ? 'is-disabled' : ''}`}>
      <div className="m-upload__inner">
        <div className="m-upload__dropzone" {...(disabled ? {} : getRootProps())}>
          <input
            id="upload"
            type="file"
            multiple={multiple}
            accept={acceptedFormat}
            onChange={onSelect}
            disabled={disabled}
            className="m-upload__input"
            onClick={(e) => e.stopPropagation()}
            ref={inputRef}
          />
          <div
            className={`m-upload__content a-input ${required ? 'is-required' : ''}`}
            onClick={(e) => e.stopPropagation()}
          >
            <label htmlFor="upload" className="m-upload__message a-input__label">
              {isLoading ? (
                <Spinner />
              ) : isDragActive ? (
                'Zet de bestanden hier neer'
              ) : (
                'Sleep een bestand hierheen of klik om te bladeren'
              )}
            </label>
          </div>
        </div>
      </div>
      <div className="a-input">
        <small>{DEFAULT_MAX_SIZE_DESCRIPTION}</small>
      </div>
      <ul className="m-upload__files">
        {files?.map((f) =>
          f.size > MAX_SIZE_MEDIA ? (
            <li key={f.name} className="is-error">
              <span className="fa fa-warning" />
              <span className="m-upload__filename">{f.name}</span>
              <span className="m-upload__error">{DEFAULT_MAX_SIZE_ERROR}</span>
              {onDelete && (
                <Button
                  className="m-upload__delete"
                  size="small"
                  type="danger"
                  icon="ai-close"
                  transparent
                  disabled={disabled}
                  onClick={() => handleDelete(f)}
                />
              )}
            </li>
          ) : (
            <li key={f.name}>
              <Icon name="ai-common-file-empty" />
              {onOpen ? (
                <LinkButton className="m-upload__filename" onClick={() => onOpen(f)}>
                  {f.name}
                </LinkButton>
              ) : (
                <span className="m-upload__filename">{f.name}</span>
              )}
              {onDelete && (
                <Button
                  className="m-upload__delete"
                  size="small"
                  type="danger"
                  icon="ai-close"
                  transparent
                  disabled={disabled}
                  onClick={() => handleDelete(f)}
                />
              )}
            </li>
          )
        )}
      </ul>
    </div>
  );
};

export default FileUpload;
